// extracted by mini-css-extract-plugin
export default {"container":"styles_container__NMoN1","item":"styles_item__GBvtS","label":"styles_label__vkrGv"};